import { http } from 'services/http';
import { CARGO_TRIPS_MANY, TRIP_GET_ONE, TRIP_TASKS_GET_MANY } from 'api/query-keys.ts';
import type { TUpdateTripTaskReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IUpdateTripTaskVariables extends TUpdateTripTaskReq {
  tripTaskId: number;
}

export const useUpdateTripTask = (tripId: number) => {
  return useMutationBase<unknown, unknown, IUpdateTripTaskVariables>({
    mutationFn: async (variables) => {
      const { tripTaskId, ...body } = variables;
      const res = await http.patch(`/v1/trips/${tripId}/trip-tasks/${tripTaskId}`, body);

      return res.data;
    },
    invalidateCallback: () => [
      [TRIP_TASKS_GET_MANY, tripId],
      [CARGO_TRIPS_MANY, tripId],
      [TRIP_GET_ONE, tripId],
    ],
  });
};
